<div class="col-md-12">
  <div class="card card-container">
    <h1>{{ 'login' | translate }}</h1>
    <br />
    <br />
    <form
      *ngIf="!isLoggedIn"
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
      <div class="form-group">
        <mat-form-field class="w-full">
          <mat-label>{{ 'username' | translate }}</mat-label>
          <input
            matInput
            type="text"
            class="w-full h-10 p-2"
            name="username"
            [(ngModel)]="form.username"
            required
            #username="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && username.errors }"
          />
        </mat-form-field>
        <div *ngIf="username.errors && f.submitted" class="invalid-feedback">
          {{ 'username_required' | translate }}
        </div>
      </div>
      <div class="form-group">
        <mat-form-field class="w-full">
          <mat-label>{{ 'password' | translate }}</mat-label>
          <input
            matInput
            type="password"
            class="w-full h-10 p-2"
            name="password"
            [(ngModel)]="form.password"
            required
            minlength="6"
            #password="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && password.errors }"
          />
        </mat-form-field>
        <div *ngIf="password.errors && f.submitted" class="invalid-feedback">
          <div *ngIf="password.errors['required']">Password is required</div>
          <div *ngIf="password.errors['minlength']">
            {{ 'password_minlength' | translate }}
          </div>
        </div>
      </div>
      <div class="text-xs">
        <div *ngIf="f.submitted && isLoginFailed" class="font-bold pt-3" role="alert">
          {{ 'login_failed' | translate }}: {{ errorMessage }}
        </div>
      </div>
      <div class="form-group">
        <button mat-raised-button
                class="mt-4"
                [disabled]="!f.form.valid">
          {{ 'login' | translate }}
        </button>
      </div>
    </form>

    <div class="alert alert-success" *ngIf="isLoggedIn">
      {{ 'logged_in_as' | translate }} {{ roles }}.
    </div>
  </div>
</div>
